<soft-resource-container class="mt-3" [resource]="resource">
  @if (resource.hasValue()) {
    <div class="flex flex-col border rounded w-full p-1.5 bg-surface mb-3">
      <span class="text-sm color-light">{{ resource.value()?.artikel?.nummer }}</span>
      <span class="text-lg font-semibold">
        {{ resource.value()?.artikel?.artbez1 }}
      </span>
      <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez2 }}</span>
      <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez3 }}</span>
      <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez4 }}</span>
      <span class="text-sm color-light"> {{ resource.value()?.artikel?.artbez5 }}</span>

      @if (resource.value().artikel?.beschreibung | isDefinedNotEmpty) {
        <span
          class="text-sm color-light"
          [innerText]="resource.value().artikel?.beschreibung"
        ></span>
      }
    </div>
  }

  <soft-mengen-eingabe
    [(value)]="quantity"
    [minValue]="0"
    [einheit]="resource.value()?.einheit?.arteh"
    [float]="true"
  ></soft-mengen-eingabe>
</soft-resource-container>

<button
  class="soft-button primary w-full h-14 mt-3"
  [disabled]="resource.isLoading() || quantity() <= 0"
  (click)="closeModal()"
>
  Bewegung erstellen
</button>
